import { render, staticRenderFns } from "./OverviewTool.vue?vue&type=template&id=4b4480c0&scoped=true"
import script from "./OverviewTool.vue?vue&type=script&lang=js"
export * from "./OverviewTool.vue?vue&type=script&lang=js"
import style0 from "./OverviewTool.vue?vue&type=style&index=0&id=4b4480c0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4480c0",
  null
  
)

export default component.exports